import type { ReactNode } from 'react';

export type Props = {
  offsetStart: number;
  offsetEnd: number;
  total: number;
};

export function SearchHits(props: Props): ReactNode {
  return (
    <div
      className="b-search-results-sorting__hits"
      dangerouslySetInnerHTML={{
        __html: I18n.t('search.search_results.results_count', {
          offsetStart: props.offsetStart,
          offsetEnd: props.offsetEnd,
          total: props.total
        })
      }}
    />
  );
}
